/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDetailsResponse as ModelsCustomerCustomerDetailsResponse } from '../../models/Models/Customer/customer-details-response';

export interface V3CustomersMeDetailsGet$Xml$Params {
}

export function v3CustomersMeDetailsGet$Xml(http: HttpClient, rootUrl: string, params?: V3CustomersMeDetailsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeDetailsGet$Xml.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>;
    })
  );
}

v3CustomersMeDetailsGet$Xml.PATH = '/v3/customers/me/details';
